import React from 'react';
import PropTypes from 'prop-types';

import { formatBase64ToSrc } from 'shared/utils/formatBase64ToSrc';

import theme from './OrganizationLogo.scss';

const propTypes = {
  organizationLogo: PropTypes.string.isRequired,
  logoLabel: PropTypes.string.isRequired,
  accessibilityEnabled: PropTypes.bool,
};

const defaultProps = {
  accessibilityEnabled: false,
};

const OrganizationLogo = ({ organizationLogo, logoLabel, accessibilityEnabled }) => (
  organizationLogo && (
    <img
      className={ theme.logo }
      src={ formatBase64ToSrc(organizationLogo) }
      alt={ logoLabel }
      tabIndex={ accessibilityEnabled ? 0 : -1 }
    />
  )
);

OrganizationLogo.propTypes = propTypes;
OrganizationLogo.defaultProps = defaultProps;

export default OrganizationLogo;
